import styled from 'styled-components';
import { Card, Button } from 'react-bootstrap';
import { IntegrationStatus } from '../../constants/integrationStatus';

export const CardWrapper = styled(Card)`
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background: #ffffff;
  transition: box-shadow 0.2s ease;
  position: relative;

  ${props => props.$upcoming && `
    opacity: 0.6;
    pointer-events: none;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 10px,
        rgba(0, 0, 0, 0.03) 10px,
        rgba(0, 0, 0, 0.03) 20px
      );
      pointer-events: none;
      z-index: 1;
    }
  `}

  &:hover {
    box-shadow: ${props => props.$upcoming ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.08)'};
  }

  .card-header {
    background: transparent;
    border-bottom: none;
    padding: 20px 20px 0;
  }

  .card-body {
    padding: 16px 20px 20px;
  }

  hr {
    border-color: #eeeeee;
    margin: 16px 0;
  }
`;

export const CardHeaderContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${props => props.$active ? '#9f173e' : '#eeeeee'};
  background: ${props => props.$active ? 'rgba(159, 23, 62, 0.1)' : 'rgba(238, 238, 238, 0.5)'};
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    color: ${props => props.$active ? '#9f173e' : '#a3a5a9'};
  }
`;

export const TitleSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CardTitle = styled.h3`
  font-family: 'Titillium Web', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #000;
  margin: 0 0 2px;
`;

export const Category = styled.span`
  font-size: 0.75rem;
  color: #a3a5a9;
  text-transform: capitalize;
`;

export const Description = styled.p`
  font-size: 0.875rem;
  color: #a3a5a9;
  line-height: 1.5;
  min-height: 40px;
  margin: 0;
`;

export const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  font-size: 0.75rem;

  ${props => props.status === IntegrationStatus.CONNECTED ? `
    color: #28a745;
    svg { color: #28a745; }
  ` : `
    color: #d91a2c;
    svg { color: #d91a2c; }
  `}

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .form-check-input:checked {
    background-color: #9f173e;
    border-color: #9f173e;
  }

  .form-check-input:focus {
    border-color: #9f173e;
    box-shadow: 0 0 0 0.25rem rgba(159, 23, 62, 0.25);
  }
`;

export const ConfigureButton = styled(Button).attrs({
  variant: 'light',
  size: 'sm'
})`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: #666;
  background: transparent;
  border: none;
  padding: 6px 12px;

  &:hover:not(:disabled) {
    background: rgba(159, 23, 62, 0.1);
    color: #9f173e;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const InfoIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  color: #a3a5a9;
  transition: color 0.15s ease;
  flex-shrink: 0;

  &:hover {
    color: #9f173e;
  }

  > svg {
    width: 14px;
    height: 14px;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CustomTooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  min-width: 280px;
  max-width: 320px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #ffffff;
  }

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 7px solid transparent;
    border-top-color: #e0e0e0;
  }
`;

export const TooltipContent = styled.div`
  text-align: left;

  .tooltip-section {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .tooltip-title {
    font-weight: 600;
    font-size: 0.75rem;
    margin-bottom: 4px;
    color: #333;
  }

  .tooltip-text {
    font-size: 0.75rem;
    line-height: 1.4;
    color: #666;
  }

  .tooltip-list {
    margin: 0;
    padding-left: 16px;
    font-size: 0.75rem;
    line-height: 1.5;
    color: #666;
  }
`;
